module.exports = __webpack_public_path__ + "static/img/Hymel-Hunt.b03b4a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hymel-Hunt.jpg
// module id = fNwd
// module chunks = 0